import React from 'react';
import { Card, CardBody } from '@one-thd/sui-atomic-components';
import { images, imgUrl } from '../../utils/consts';

interface IGCSeleImageProps {
  userSelectedImg?: string;
  onImageSelect: (img: string) => void;
}

export const GiftCardSelectImage: React.FC<IGCSeleImageProps> = ({
  userSelectedImg,
  onImageSelect
}) => {
  return (
    <div className="sui-w-full sui-flex sui-flex-col sui-justify-center">
      <div
        className="sui-grid sui-grid-cols-2 sui-gap-4 sui-mb-4
          lg:sui-grid-cols-3"
      >
        {images.map((img, index) => (
          <Card
            key={img}
            onClick={() => onImageSelect(img)}
            PaperProps={{
              className: img === userSelectedImg ? 'sui-border-2 sui-border-strongest' : ''
            }}
            data-testid={`gc-img-${index}`}
          >
            <CardBody>
              <img
                className="sui-rounded-md sui-p-1 sui-my-2 sui-mx-auto"
                src={`${imgUrl.host}${imgUrl.pathname}${img}`}
                alt={`gc-img-${index}`}
                height="80"
                width="150"
              />
            </CardBody>
          </Card>
        ))}
      </div>
    </div>
  );
};
